 document.addEventListener('DOMContentLoaded', function () {
    new Splide('#article-splide-slider', {
      type   : 'loop',
      perPage: 3,
      gap    : '2.3rem',
      pagination:false,
      breakpoints: {
        768: { perPage: 1 },
        1024: { perPage: 2 }
      }
    }).mount();
  });